<mat-accordion class="panel-accordion-container" hideToggle="true">
  <mat-expansion-panel
    (opened)="triggerOpenedPanelStateEvent(0)"
    (closed)="triggerClosedPanelStateEvent()"
    [expanded]="true"
    #matExpansionPanelElement>
    <mat-expansion-panel-header>
      <mat-panel-title>{{ title }}</mat-panel-title>
      <rd-shared-icon
        class="link-icon-image toggle-icon mt-2 h-4 w-4"
        [iconSymbol]="toggleIcon"
        [iconTheme]="'primary'"></rd-shared-icon>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="bodyContent"></ng-container>
    <ng-container *ngIf="bodyText">{{ bodyText }}</ng-container>
  </mat-expansion-panel>
</mat-accordion>
